import DimensionsView from '@/dimensions/DimensionsView.vue'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {PanelContent} from '@tritt/multipanel'

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

export const DIMENSIONS: PanelContent= {
    componentName: 'Dimensions',
    path: '/dimensions',
    component: DimensionsView,
    meta: {requiresOrg: true}
}
registerRoute(DIMENSIONS)
const label = 'Dimensjoner'
const icon = 'i-ph-tag-fill'
registerNavigationCommand({
    route: DIMENSIONS,
    label,
    icon
})
registerNavigationEntry(NavGroup.MISC, {
    title: label,
    key: 'dimensions',
    icon,
    target: DIMENSIONS,
    sortOrder: 4
})
buildSimpleCrumb(DIMENSIONS, label, icon)
